(() => {
  if (window.NexoWishlistAnalytics) return;
  const config = document.querySelector('[data-nxo-wishlist-config]');
  if (!config) return;
  const actions = new Set(['saved', 'removed', 'opened', 'product_viewed', 'added_to_cart']);
  const sources = new Set(['card', 'product', 'drawer', 'header']);
  const pathKey = 'nexo:wishlist:journey:v1';
  const pathLifetime = 30 * 60 * 1000;
  const wishlistPath = (action, handle) => {
    try {
      if (action === 'product_viewed') {
        window.sessionStorage.setItem(pathKey, JSON.stringify({ handle, at: Date.now() }));
        return false;
      }
      if (action !== 'added_to_cart') return false;
      const previous = JSON.parse(window.sessionStorage.getItem(pathKey) || 'null');
      if (!previous || previous.handle !== handle) return false;
      window.sessionStorage.removeItem(pathKey);
      const age = Date.now() - previous.at;
      return Number.isFinite(age) && age >= 0 && age <= pathLifetime;
    } catch { return false; }
  };
  let loadingPrivacy = false;
  const loadPrivacy = () => {
    const shopify = window.Shopify;
    if (loadingPrivacy || shopify?.customerPrivacy || typeof shopify?.loadFeatures !== 'function') return;
    loadingPrivacy = true;
    try { shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => { loadingPrivacy = false; }); }
    catch { loadingPrivacy = false; }
  };
  const track = (action, details = {}) => {
    if (!actions.has(action) || config.dataset.designMode === 'true') return false;
    const shopify = window.Shopify;
    try {
      if (typeof shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') { loadPrivacy(); return false; }
      if (!shopify.customerPrivacy.analyticsProcessingAllowed() || typeof shopify?.analytics?.publish !== 'function') return false;
      const data = {
        feature_version: '23',
        theme_id: config.dataset.themeId,
        source: sources.has(details.source) ? details.source : 'drawer',
        wishlist_count: Math.max(0, Math.min(80, Number(details.count) || 0))
      };
      if (/^[a-z0-9][a-z0-9-]{0,254}$/.test(details.handle || '')) data.product_handle = details.handle;
      if (/^\d+$/.test(String(details.productId || ''))) data.product_id = String(details.productId);
      if (data.product_handle && typeof details.productTitle === 'string') data.product_title = details.productTitle.slice(0, 200);
      if (data.product_handle) data.wishlist_path = wishlistPath(action, data.product_handle);
      if (action === 'added_to_cart') {
        data.quantity = Math.max(1, Math.min(9999, Math.floor(Number(details.quantity) || 1)));
        if (/^[A-Z]{3}$/.test(config.dataset.currency || '')) data.currency = config.dataset.currency;
        const price = Number(details.price);
        if (Number.isFinite(price) && price >= 0) data.price = price;
      }
      const published = shopify.analytics.publish(`nexo:wishlist_${action}`, data);
      if (published && typeof published.then === 'function') return published.then(() => true, () => false);
      return published !== false;
    } catch { return false; }
  };
  window.NexoWishlistAnalytics = Object.freeze({ track });
  loadPrivacy();
})();
